import get from './get';
import post from './post';
import id from './{id}';

export default { get, post, id };
